import React from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import { SearchPanelContainer } from '@components/Search'
import { DatePickerRange } from '@components/DatePicker'
import FilterGroup from '@components/FilterGroup'
import { Dropdown } from '@components/Autocomplete'
import OptionGroup, { CheckboxOption } from '@components/OptionGroup'
import Checkbox from '@components/Checkbox'

function ExpertPaymentsFilterPanel ({
  expertPaymentsStore,
  atheneumOfficeStore
}) {
  const { search, query, staticData, getDefaultQuery } = expertPaymentsStore

  const { paymentStatuses } = staticData.names

  const atheneumOffices = [
    { id: null, name: 'All offices' },
    ...atheneumOfficeStore.atheneumOffices
  ]
  return (
    <SearchPanelContainer
      extrathin
      searchTitle='Search'
      onClearSearch={() => search(getDefaultQuery())}
    >
      <FilterGroup label='Search' onSearch={() => search({ page: 1 })}>
        <input
          type='text'
          value={query.searchString}
          onChange={({ target }) => {
            query.searchString = target.value
          }}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              return search({ page: 1 })
            }
          }}
        />
      </FilterGroup>
      <FilterGroup label='Consultation date'>
        <DatePickerRange
          onFromChange={date => search({ fromDate: date, page: 1 })}
          onToChange={date => search({ toDate: date, page: 1 })}
          fromDate={query.fromDate}
          toDate={query.toDate}
        />
      </FilterGroup>
      <FilterGroup label='Atheneum office'>
        <Dropdown
          selectedItem={atheneumOffices.find(
            ({ id }) => id === query.atheneumOfficeId
          )}
          itemToString={item => item && item.name}
          onChange={value => search({ atheneumOfficeId: value.id, page: 1 })}
          options={atheneumOffices}
        />
      </FilterGroup>
      <FilterGroup>
        <Checkbox
          label='Invoiced'
          value={query.invoiced}
          onChange={checked => search({ invoiced: checked, page: 1 })}
        />
      </FilterGroup>
      <FilterGroup label='Payment status'>
        <OptionGroup
          noStyle
          items={staticData.paymentStatuses.map(({ id }) => id)}
          selectedItems={query.cpdPaymentStatusIds.slice()}
          itemToString={item => item && paymentStatuses[item]}
          onChange={selectedItems =>
            search({ cpdPaymentStatusIds: selectedItems, page: 1 })
          }
          renderItem={CheckboxOption}
        />
      </FilterGroup>
      <FilterGroup label='Invoice number'>
        {query.invoiceNumbers?.length ? (
          <>
            <span>
              Filtering by {query.invoiceNumbers.length} invoice numbers
            </span>{' '}
            <a
              href=''
              onClick={() => search({ invoiceNumbers: null, page: 1 })}
            >
              clear
            </a>
          </>
        ) : (
          <button
            className='button button--primary'
            onClick={() => {
              const res = prompt('Please paste invoice ids')
              const ids = res
                .split('\n')
                .map(a => Number(a))
                .filter(a => Number.isInteger(a))
              search({ invoiceNumbers: ids, page: 1 })
            }}
          >
            Filter by invoice number
          </button>
        )}
      </FilterGroup>
    </SearchPanelContainer>
  )
}

ExpertPaymentsFilterPanel.propTypes = {
  atheneumOfficeStore: PropTypes.object.isRequired,
  expertPaymentsStore: PropTypes.object.isRequired
}

export default inject('atheneumOfficeStore')(
  observer(ExpertPaymentsFilterPanel)
)
